/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-20 16:24:34
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/concrete/queryPage'
export const batchUpdateOrDelete = '/icps/system/sign/basics/rawMaterials/deletes'
export const updateSortNum = ''
export const saveOrUpdate = '/icps/system/sign/basics/rawMaterials/saveOrUpdate'
export const Download = '/icps/system/sign/basics/rawMaterials/exportList'
/*获取列表*/
export function queryMaterialsPage() {
  return request({
    url: '/icps/system/sign/basics/rawMaterials/QueryList',
    method: 'post'
  })
}
export function getListByPid(data) {
  return request({
    url: '/icps/system/sign/intelligent/component/getListByPid',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取测区
 * @param {*} data
 * @Author: wangwangwang
 */
export function getTestIngZones(data) {
  return request({
    url: '/icps/system/sign/intelligent/component/getTestIngZones',
    method: 'post',
    data
  })
}